//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uid } from "quasar";
import draggable from "vuedraggable";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import PluginReadonlyContainer from "../../sidebar/plugin-readonly-container.vue";
import { PLUGIN_CUSTOM_PROPS } from "../../sidebar/const/plugin-custom-props";

export default {
    name: "SetApiRules",
    components: {
        setConditions,
        draggable,
        PluginReadonlyContainer,
        AQModal,
        AQDropdown,
        AQChip,
        AQCard
    },
    props: {
        arrayPath: Array,
        arrayRules: Array,
        value: { type: Boolean, default: false }
    },
    data() {
        return {
            sizeCanvas: PLUGIN_CUSTOM_PROPS,
            add: {
                label: this.$t("generic.add"),
                disabled: false
            },
            ruleModal: false,
            rulePath: "",
            drag: false,
            noPathSelected: false,
            saveEnable: false,
            conditions: {},
            ruleObject: {},
            indexValue: null,
            disabledAdd: false,
            uuidValue: null,
            arrayOption: [],
            newValue: false,
            arrayRulesList: [],
            extendParent: false,
            errorLabel: "",
            headerActions: [{ label: this.$t("diagrams.components.setRules.delete") }],
            showSave: { label: this.$t("diagrams.components.configApi.addBtn") },
            selectPathMod: [],
            resetPathMod: false,
            openDataFirstTime: false
        };
    },

    computed: {
        getSelectPathProps() {
            return {
                label: this.$t("diagrams.components.configApi.actionErr"),
                options: this.arrayPath,
                errorLabel: this.$t("diagrams.components.configApi.warningDefultPath"),
                error: this.noPathSelected,
                resetSelectedData: this.resetPathMod,
                disable: !this.arrayPath.length
            };
        }
    },

    watch: {
        arrayRules: {
            handler(value) {
                this.arrayRulesList = [...value];
            },
            immediate: true
        },
        value: {
            handler(newValue) {
                this.ruleModal = newValue;
                this.newValue = newValue;
            },
            immediate: true
        }
    },

    methods: {
        action($event) {
            if ($event === "primary") {
                let idPlugin = null;
                let idLabel = null;
                this.ruleObject = {};
                const conditionsAdd = this.verifyCondition(this.conditions);
                const rulePathExist = this.verifyRule(this.rulePath);
                if (rulePathExist) {
                    if (conditionsAdd.conditions && conditionsAdd.values) {
                        const plugin = this.arrayPath.find(element => element.value === this.rulePath);
                        if (plugin) {
                            idPlugin = plugin.iconName;
                            idLabel = plugin.label;
                            if (this.newValue) {
                                this.ruleObject = {
                                    path: this.rulePath,
                                    conditions: this.conditions,
                                    index: this.arrayRulesList && this.arrayRulesList.length ? this.arrayRulesList.length : 0,
                                    uuid: uid(),
                                    idPlugin,
                                    labelPlugin: idLabel
                                };
                                this.arrayRulesList = [...this.arrayRulesList, ...[this.ruleObject]];
                            } else {
                                this.ruleObject = {
                                    path: this.rulePath,
                                    conditions: this.conditions,
                                    index: this.indexValue,
                                    uuid: this.uuidValue,
                                    idPlugin,
                                    labelPlugin: idLabel
                                };
                                this.arrayRulesList[this.indexValue] = this.ruleObject;
                            }
                        }
                        this.ruleModal = false;
                        this.newValue = false;
                        this.$emit("updateResponse", this.arrayRulesList);
                    } else {
                        this.$toast.showNotify({
                            type: "error",
                            message: !conditionsAdd.conditions ? this.$t("diagrams.components.configApi.errRule")
                                : this.$t("diagrams.components.configApi.errRuleValues")
                        });
                    }
                }
            } else if ($event === this.$t("diagrams.components.setRules.delete")) {
                if (typeof this.indexValue === "number") {
                    this.arrayRulesList.splice(this.indexValue, 1);
                    this.$emit("updateResponse", this.arrayRulesList);
                }
                this.ruleModal = false;
            } else {
                this.ruleModal = false;
                this.newValue = false;
                this.$emit("updateResponse", this.arrayRulesList);
            }
            this.$emit("input", this.ruleModal);
        },
        verifyData() {
            this.add.disabled = this.openDataFirstTime || !(this.rulePath && this.conditions);
            this.openDataFirstTime = false;
        },
        verifyCondition(value) {
            let hasValues = true;
            let hasConditions = true;
            const { conditions } = value;
            if (conditions && conditions.length) {
                for (let i = 0; i < conditions.length; i++) {
                    if (conditions[i].type === "group") {
                        const emptyValues = conditions[i].conditions.some(elem => !elem.val1.value || !elem.val2.value);
                        if (emptyValues) {
                            hasValues = false;
                            break;
                        }
                    } else if (!conditions[i].val1.value || !conditions[i].val2.value) {
                        hasValues = false;
                        break;
                    }
                }
            } else {
                hasConditions = false;
            }

            const validationsObject = {
                conditions: hasConditions,
                values: hasValues
            };

            return validationsObject;
        },
        verifyRule(value) {
            let pathToReturn = false;
            if (value) {
                pathToReturn = true;
                this.noPathSelected = false;
            } else {
                this.noPathSelected = true;
                pathToReturn = false;
            }
            return pathToReturn;
        },
        changeOrder() {
            this.$emit("updateResponse", this.arrayRulesList);
        },
        valueSelected(value) {
            this.rulePath = value.length ? value[0].value : "";
            this.verifyData();
        },
        openModal(value, index) {
            this.extendParent = false;
            this.add.disabled = true;
            this.openDataFirstTime = true;
            if (this.newValue) {
                this.ruleModal = true;
                this.resetPathMod = true;
                setTimeout(() => {
                    this.resetPathMod = false;
                }, 0);
                this.conditions = {};
            } else {
                this.ruleModal = true;
                this.resetPathMod = true;
                setTimeout(() => {
                    this.resetPathMod = false;
                }, 0);
                this.indexValue = index;
                this.uuidValue = value.uuid;
                this.conditions = {};
                this.selectPathMod = this.arrayPath.filter(elem => elem.value === value.path);
                this.rulePath = this.selectPathMod.length ? this.selectPathMod[0].value : "";
                if (value && value.conditions) {
                    if (!value.conditions.conditions) {
                        this.conditions.conditions = [];
                        this.conditions.conditions.push(value.conditions);
                    } else if (value.conditions.conditions) {
                        this.conditions = value.conditions;
                    }
                }
            }
        }
    }
};
